import { UIActionType, UIAction } from '../../actions/uiActions';

const onboardingCompletedDialogReducer = (state = false, action: UIAction) => {
  switch (action.type) {
    case UIActionType.TOGGLE_ONBOARDING_COMPLETED_DIALOG:
      return !state;
    default:
      return state;
  }
};

export default onboardingCompletedDialogReducer;
